import React, { useMemo } from 'react';
// FIXME: remove Semantic UI
import { TYPE_CHART_TIMELINE, Chart } from 'stoerk-ui-components';
import { isEmpty } from 'validate.js';
import { Alert, useTheme } from '@mui/material';
import filterDigitalChannelsByInternalTime from '../../../../redux/monitoring/api/util/filter/filterDigitalChannelsByInternalTime';

import { getLanguage } from '../../../../i18n';
import { DigitalChannelsProps } from '../../../../components/DeviceManager/Device/Monitoring/components/ComboCharts/DigitalChannels';

export const DigitalChannelsFW = React.memo(function DigitalChannelsFW(
  props: DigitalChannelsProps
) {
  const { data, polyglot, internalTimeFrame, labels, width, height } = props;
  const dataEmpty = isEmpty(data);
  const dataFilteredByInternalTime = useMemo(
    () => filterDigitalChannelsByInternalTime(data, internalTimeFrame),
    [data, internalTimeFrame]
  );

  const theme = useTheme();
  const palette = useMemo(() => {
    return Array.from(Object.keys(dataFilteredByInternalTime)).map(
      () => theme.palette.primary.main
    );
  }, [dataFilteredByInternalTime, theme.palette.primary.main]);

  if (dataEmpty)
    return (
      <Alert severity="warning">
        {polyglot.t('device.monitoring.not_data_to_show_digital_channels')}
      </Alert>
    );
  return (
    <Chart
      data={dataFilteredByInternalTime}
      type={TYPE_CHART_TIMELINE}
      height={height}
      width={width}
      minDatetime={internalTimeFrame.start.unix()}
      maxDatetime={internalTimeFrame.end.unix()}
      zoom={true}
      language={getLanguage()}
      labels={labels}
      getColorPalette={() => palette}
    />
  );
});
